<template>
 <v-row justify="center" align="center">
    <div class="text-center ma-12">
    <v-progress-circular
      :rotate="360"
      :size="120"
      :width="15"
      :value="value"
      color="teal"
    >
      {{ value }}
    </v-progress-circular>
        </div>
  </v-row>
</template>



<script>
  export default {
    data () {
      return {
        interval: {},
        value: 88,
        indeterminate: false,
        rotate: 0,
        size: 100,
        width: 4,
        
      }
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 88) {
          return (this.value = 0)
        }
        this.value += 2
      }, 1000)
    },
  }
</script>

<style scoped>
.v-progress-circular {
  /* margin: 1rem; */
}
</style>